// extracted by mini-css-extract-plugin
module.exports = {"yesNoEntry":"yesNoEntry_Ha6iv","description":"description_x5Bg2","detailedDescription":"detailedDescription_37Eo0","yesNo":"yesNo_2C5NW"};